module.exports = __webpack_public_path__ + "media/arek4.d0778f25.mp3";